<template>
  <div
    class="card-standard--actions"
    :class="actionsClasses"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { cx } from '@/helpers'

defineOptions({ name: 'CardActions' })
const props = defineProps({
  align: {
    type: String,
    default: 'left',
    validator: v => [
      'left',
      'center',
      'right',
      'between',
      'around',
      'evenly',
      'stretch'
    ].includes(v)
  },
  vertical: { type: Boolean, default: false }
})

const actionsClasses = computed(() => cx(
  props.vertical && 'is-vertical',
  `align-${props.align}`
))
</script>
